module.exports = __webpack_public_path__ + "img/interception_left.063bc4ee.jpg";